import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { Status } from "../../Config/Status.js";
import { Options } from "../../Config/Options.js";

const BusinessVideoGsap = {
  gsapWrap: document.querySelector('[data-gsap-wrap]'),
  gsapScale: document.querySelector('[data-gsap-scale]'),

  init() {
    gsap.registerPlugin(ScrollTrigger);
      gsap.to(this.gsapScale, {
        ease: "none",
        scale: 1,
        scrollTrigger: {
          trigger: this.gsapWrap, // アニメーションが始まるトリガーとなる要素。
          start: "top bottom", // アニメーションが始まる位置
          end: "center center+=15%", // アニメーションが終わる位置
          // end: () => "bottom", // アニメーション開始位置から固定する距離
          pin: false, // トリガー要素を固定する
          scrub: 0.9, // スクロール量に応じてアニメーション
          invalidateOnRefresh: true, // リサイズ再計算？
          anticipatePin: 1, // 素早いスクロールに対するピン留め遅延回避
          // once: true,
          // markers: true,
        },
      });
  },
}

export default BusinessVideoGsap;